import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_COMBO_SHARE_CTA_COPY_EXPERIMENT = defineFcm('combo_share_cta_copy_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				experimentName: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'psf promote_or_share combo page',
		description:
			'Gates the combo share CTA button copy experiment (5-arm label-string test: control, fake_control, 3 treated variants)',
		import: false,
		deprecated: 'FCM no longer in use — safe to delete after 2026-08-19',
		template: {
			enabled: false,
			experimentName: 'combo_share_cta_copy_experiment',
		},
	});
